import GraphContainer from "./graph_container";

class GraphGroup extends GraphContainer {
    constructor() {
        const dom = GraphContainer.createDOM("g");

        super(dom);

        this._dom = dom;
        this._uuid = THREE.Math.generateUUID();
        this.setAttribute("id", this._uuid);
    }

    get uuid() { return this._uuid; }
    set uuid(uuid) {
        this._uuid = uuid;
        this.setAttribute("id", uuid);
    }

    addEventListener(type, listener, options) {
        this._dom.addEventListener(type, listener, options);

        return this;
    }

    show() {
        this._dom.setAttribute("display", "block");

        return this;
    }

    hide() {
        this._dom.setAttribute("display", "none");

        return this;
    }
}

export default GraphGroup;
export { GraphGroup };